import React from "react";

export default function Bacteriology() {
  return <div>Bacteriology</div>;
}
